import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/intercom': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M392 32c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56h-336c-30.9 0-56-25.1-56-56v-336c0-30.9 25.1-56 56-56h336zM283.7 114.1v199.5c0 19.8 29.9 19.8 29.9 0v-199.5c0-19.8-29.9-19.8-29.9 0zM209.1 106.6v216.5c0 19.8 29.9 19.8 29.9 0v-216.5c0-19.8-29.9-19.8-29.9 0zM134.4 114.1v199.5c0 19.8 29.9 19.8 29.9 0v-199.5c0-19.8-29.9-19.8-29.9 0zM59.7 144v134.3c0 19.8 29.9 19.8 29.9 0v-134.3c0-19.8-29.9-19.8-29.9 0zM383.1 371.8c14.9-12.9-4.5-35.6-19.4-22.7-63.2 53.9-213.4 55.3-279.3 0-15-12.8-34.4 9.9-19.4 22.7 76.4 65.4 245.3 63 318.1 0zM388.3 278.3v-134.3c0-19.8-29.9-19.8-29.9 0v134.3c0 19.8 29.9 19.8 29.9 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/intercom.js
// module id = 887
// module chunks = 0